module.exports = __webpack_public_path__ + "img/UTANTE-2.7a8084f5.jpg";